import React from 'react'
import { Button } from '@/components/ui/button'
import { Heading3 } from '@/components/ui/typography'
import { BonusTransactionDto } from 'api/Transaction/Types/BonusTransactionDto'
import {
  FormBaseButtonContainer,
  FormBaseContainer,
  FormBaseFieldBlock,
  FormBaseFieldGroup,
  FormBaseFieldLabel,
  FormBaseRow,
} from 'components/Form/Form.styles'
import { Field, Form, FormikErrors, FormikProps, withFormik } from 'formik'
import { FormErrorMessage } from 'routes/Transactions/Transactions.styles'
import { FormSubmitValues } from 'utils/formValidation'

export interface BonusTransactionFormValues {
  id: string
  walletTransactionId: string
  amount: number
}

const ReduceBonusReservedFormModalUI: React.FC<
  FormikProps<BonusTransactionFormValues> & OuterProps
> = (props) => {
  const { errors, isSubmitting, handleSubmit, setSubmitting, bonusTransaction } = props

  const onSubmit = () => {
    setSubmitting(true)
    handleSubmit()
  }

  return (
    <FormBaseContainer>
      <Form>
        <Heading3>
          Reverse Transaction <span className='blue'>({bonusTransaction.referenceId})</span>
        </Heading3>
        <FormBaseFieldBlock>
          <FormBaseRow>
            <FormBaseFieldLabel>Reduce bonus reserved by</FormBaseFieldLabel>
            <FormBaseFieldGroup>
              <Field placeholder='Amount' name='amount' />
            </FormBaseFieldGroup>
          </FormBaseRow>
          {errors.amount && <FormErrorMessage>{errors.amount}</FormErrorMessage>}
        </FormBaseFieldBlock>
        <FormBaseButtonContainer>
          <Button onClick={onSubmit} disabled={isSubmitting} key='button' type='button'>
            Submit
          </Button>
        </FormBaseButtonContainer>
      </Form>
    </FormBaseContainer>
  )
}

interface OuterProps {
  bonusTransaction: BonusTransactionDto
  onSubmit(values: FormSubmitValues<BonusTransactionFormValues>): void
}

export const ReduceBonusReservedFormModal = withFormik<OuterProps, BonusTransactionFormValues>({
  mapPropsToValues: (props) => {
    return {
      id: props.bonusTransaction.id,
      walletTransactionId: props.bonusTransaction.walletTransactionId,
      amount: props.bonusTransaction.bonusReserved,
    }
  },
  handleSubmit: async (values, { props, setSubmitting }) => {
    await props.onSubmit(values)
    setSubmitting(false)
  },
  validate: (values, props) => {
    const errors: FormikErrors<BonusTransactionFormValues> = {}
    if (!values.amount) {
      errors.amount = 'required'
    }
    if (values.amount < 0) {
      errors.amount = 'Amount less than 0'
    }
    if (values.amount > props.bonusTransaction.bonusReserved) {
      errors.amount = `Amount greater than ${props.bonusTransaction.bonusReserved}`
    }
    return errors
  },
  enableReinitialize: true,
  isInitialValid: false,
})(ReduceBonusReservedFormModalUI)
